import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { IconButton } from '@mui/material';
import React, { useState } from 'react';
import css from './DiscountIcon.module.css';
import DiscountInfoDialog from './DiscountInfoDialog';

export const DiscountIcon = ({ discount, currency, intl }) => {
  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleDialogClose = e => {
    e.preventDefault();
    e.stopPropagation();
    setDialogOpen(false);
  };

  const maxDiscountInSubunits = discount?.maxDiscount?.[currency];
  const isCapped = !!discount?.isCapped && !!maxDiscountInSubunits;
  if (!isCapped) return null;

  return (
    <>
      <IconButton
        onClick={() => setDialogOpen(true)}
        size="small"
        className={css.helpIcon}
        sx={{ width: '16px', height: '16px' }}
      >
        <HelpOutlineIcon sx={{ fontSize: '16px' }} />
      </IconButton>
      <DiscountInfoDialog
        isOpen={isDialogOpen}
        onClose={handleDialogClose}
        discount={discount}
        currency={currency}
        intl={intl}
      />
    </>
  );
};
